import React from 'react';

export const INGREDIENT_MODEL = {
    id: null,
    name: '',
    description: '',
    code: '',
    measurementUnitId: null,
    isValid: function () {
        return this.name != '' && this.code != '' && this.measurementUnitId != '' && this.measurementUnitId != null;
    },
    toAddEdit: function () {
        return {
            id: this.id,
            name: this.name,
            description: this.description,
            code: this.code,
            measurementUnitId: this.measurementUnitId
        }
    }
}

export const MODEL_MEASUREMENT_UNIT = {
    kilogram: {
        id: 1,
        name: "Kilogram",
        trans: "kilogram"
    },
    gram: {
        id: 2,
        name: "Gram",
        trans: "gram"
    },
    unit: {
        id: 3,
        name: "Unit",
        trans: "unit"
    },
    liter: {
        id: 4,
        name: "Liter",
        trans: "liter"
    },
    mililiter: {
        id: 5,
        name: "Mililiter",
        trans: "mililiter"
    },
    package: {
        id: 6,
        name: "Package",
        trans: "package"
    },
    pound: {
        id: 7,
        name: "Pound",
        trans: "pound"
    },
    bunch: {
        id: 8,
        name: "Bunch",
        trans: "bunch"
    },
    ounce: {
        id: 9,
        name: "Ounce",
        trans: "ounce"
    },
    roll: {
        id: 10,
        name: "Roll",
        trans: "roll"
    },
    dozen: {
        id: 11,
        name: "Dozen",
        trans: "dozen"
    },
    gallon: {
        id: 12,
        name: "Gallon",
        trans: "gallon"
    }
};

export function getUnitTransByName(name) {
    if(!name) return "";

    return Object.values(MODEL_MEASUREMENT_UNIT).find(
        (unit) => unit.name.toLowerCase() === name?.toLowerCase()
    )?.trans || name || "";
}
